import {lazy, useEffect} from 'react';
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom';
import {useSelector} from 'react-redux';

import Ping from '@configs/request/Ping';
import {canViewMenuItem} from '@utils/misc';

import {Routes as routeConfigs} from './routes';
import WebPaths from "./paths/web";
import {useRouterTransition} from "../hooks/useRouterTransition";
import ScrollToTop from "@utils/ScrollToTop";

// Import layouts
import EmptyLayout from '@layouts/empty';
import BlankLayout from '@layouts/blank';
import WebLayout from '@layouts/web';
import PanelLayout from '@layouts/panel';

// Import error pages
const ErrorPage = lazy(() => import('@errorViews/Error'));
const NotAuthorizedPage = lazy(() => import('@errorViews/NotAuthorized'));
const ForbiddenPage = lazy(() => import('@errorViews/403'));
const ServerErrorPage = lazy(() => import('@errorViews/500'));

const AppRouter = () => {
    const {transition, setTransition} = useRouterTransition();
    const auth = useSelector(state => state.auth);

    const layouts = {EmptyLayout, BlankLayout, PanelLayout, WebLayout};

    // Ping API on component mount
    useEffect(() => {
        Ping();
    }, []);

    return (
        <Router basename={process.env.REACT_APP_BASENAME}>
            <ScrollToTop/>
            <Routes>
                {/* Blank Route */}
                {routeConfigs.web.map((route, index) => {
                    const SpecificLayout = layouts[route.layout];
                    return (
                        !route.disabled && (
                            <Route
                                key={index} path={WebPaths.home} element={<SpecificLayout/>}>
                                <Route
                                    path={route.path}
                                    element={
                                        route.auth && (!auth.token || !canViewMenuItem(route, auth)) ? (
                                            <Navigate to={WebPaths.errors["401"]}/>
                                        ) : (
                                            <route.component/>
                                        )
                                    }
                                />
                            </Route>
                        )
                    )
                })}
                {routeConfigs.panel.map((route, index) => {
                    const SpecificLayout = layouts[route.layout] || layouts.PanelLayout;
                    return (
                        route.auth ? (
                            <Route
                                key={index} path="/panel" element={<SpecificLayout/>}>
                                <Route
                                    path={route.path}
                                    element={
                                        !auth.token ? (
                                            <Navigate to={WebPaths.errors["401"]}/>
                                        ) : !canViewMenuItem(route, auth) ? (
                                            <ForbiddenPage/>
                                        ) : (
                                            <route.component/>
                                        )
                                    }
                                />
                            </Route>
                        ) : (
                            <Route key={index} path={route.path} element={<route.component/>}/>
                        )
                    )
                })}
                {/* Panel Route */}
                {/*<Route path="/panel" element={<layouts.PanelLayout transition={transition}/>}>
                    {routeConfigs.panel.map((route, index) => (
                        route.auth ? (
                            <Route
                                key={index}
                                path={route.path}
                                element={
                                    !auth.token ? (
                                        <Navigate to="/401"/>
                                    ) : !canViewMenuItem(route, auth) ? (
                                        <ForbiddenPage/>
                                    ) : (
                                        <route.component/>
                                    )
                                }
                            />
                        ) : (
                            <Route key={index} path={route.path} element={<route.component/>}/>
                        )
                    ))}
                </Route>*/}

                <Route path={WebPaths.home} element={<BlankLayout/>}>
                    <Route path={WebPaths.errors["500"]} element={<ServerErrorPage/>}/>
                    <Route path={WebPaths.errors["404"]} element={<ErrorPage/>}/>
                    <Route path={WebPaths.errors["401"]} element={<NotAuthorizedPage/>}/>
                </Route>
                {/* Default Route */}
                <Route path="*" element={<Navigate to={WebPaths.errors["404"]}/>}/>
            </Routes>
        </Router>
    );
};

export default AppRouter;
